import i18next from "i18next";
import getBrowserErrorType, { BrowserErrorType } from "../getBrowserErrorType.js";
import Logging from "../Logging.js";
import { ServiceResponseError, RequestTimeoutError, NetworkRequestFailedError, StatusCode } from "../services/ServiceBase.js";
import notificationStore from "./notificationStore.js";
import processingStore from "./processingStore.js";
import sharedTranslationStore from "./sharedTranslationStore.js";
import StateStoreBase from "./StateStoreBase.js";
class ErrorStore extends StateStoreBase {
  constructor() {
    super(...arguments);
    this.errorInfo = { hasError: false, message: "" };
  }
  clear() {
    this.errorInfo = {
      hasError: false,
      message: "",
      retryAuthentication: void 0,
      title: void 0,
      traceId: void 0
    };
    this.notifySubscribers();
  }
  get() {
    return this.errorInfo;
  }
  getTraceId(exception, log) {
    if (log == null ? void 0 : log.traceId) {
      return log.traceId;
    }
    if (exception instanceof ServiceResponseError) {
      return exception.traceId;
    }
    return void 0;
  }
  logException(exception) {
    void Logging.error(exception).then((log) => {
      this.errorInfo = {
        ...this.errorInfo,
        traceId: this.getTraceId(exception, log)
      };
      this.notifySubscribers();
    });
  }
  showExceptionNotification(exception, message) {
    if (this.isRetryAuthenticationException(exception)) {
      this.showExceptionPage(exception);
      return;
    }
    void Logging.error(exception);
    notificationStore.show(
      this.getWrappedExceptionMessage(exception, message),
      "error"
    );
  }
  showExceptionPage(exception, log = true) {
    processingStore.pageLoadingStarted();
    this.show(
      this.getExceptionMessage(exception),
      void 0,
      this.isRetryAuthenticationException(exception)
    );
    if (log) {
      this.logException(exception);
    }
  }
  showPage(message, title) {
    this.show(message, title);
  }
  getExceptionMessage(exception, message) {
    let finalMessage = message;
    if (exception instanceof RequestTimeoutError || exception instanceof NetworkRequestFailedError) {
      finalMessage = i18next.t("frame:Error.Connection");
    } else if (exception instanceof ServiceResponseError) {
      switch (exception.statusCode) {
        case StatusCode.BadRequest:
          if (exception.userMessage) {
            finalMessage = exception.userMessage;
          }
          break;
        case StatusCode.Forbidden:
        case StatusCode.Unauthorized:
          finalMessage = i18next.t("frame:Error.Unauthorized");
          break;
      }
    }
    switch (getBrowserErrorType(exception)) {
      case BrowserErrorType.cache:
        finalMessage = i18next.t("frame:Error.BrowserCache");
        break;
      case BrowserErrorType.plugin:
        finalMessage = i18next.t("frame:Error.BrowserPlugin");
        break;
    }
    return finalMessage;
  }
  getWrappedExceptionMessage(exception, message) {
    let completeMessage = this.getExceptionMessage(exception, message);
    if (!completeMessage) {
      const genericError = sharedTranslationStore.get().genericError();
      completeMessage = genericError ? genericError : i18next.t("frame:Error.Occurred");
    }
    if (i18next.exists("frame:Error.TryAgain")) {
      if (!completeMessage.endsWith(".")) {
        completeMessage += ".";
      }
      return `${completeMessage} ${i18next.t("frame:Error.TryAgain")}`;
    }
    return completeMessage;
  }
  isRetryAuthenticationException(exception) {
    return exception instanceof ServiceResponseError && exception.retryAuthentication;
  }
  show(message, title, retryAuthentication) {
    this.errorInfo = {
      hasError: true,
      message,
      retryAuthentication,
      title,
      traceId: void 0
    };
    this.notifySubscribers();
  }
}
const errorStore = new ErrorStore();
export {
  ErrorStore,
  errorStore as default
};
//# sourceMappingURL=errorStore.js.map
